export var SortOrder = /*#__PURE__*/function (SortOrder) {
  SortOrder["ASC"] = "asc";
  SortOrder["DESC"] = "desc";
  return SortOrder;
}({});